<template>
  <div class="page-wrapper storybook-cncIconButton">
    <StorybookTemplate title="CncIconButton" pathComponent="/shared/elements/global/v1/CncIconButton.vue" :propList="propList" :form.sync="form">
      <CncIconButton v-bind="form">{{ form.name }}</CncIconButton>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        {
          name: 'type',
          type: 'select',
          param: 'type',
          default: 'filled',
          option: [
            { label: 'filled', name: 'Filled' },
            { label: 'tonal', name: 'Tonal' },
            { label: 'tonal-outlined', name: 'Tonal outlined' },
            { label: 'tonal-alt', name: 'Tonal alt' },
            { label: 'tonal-alt-outlined', name: 'Tonal alt outlined' },
            { label: 'neutral', name: 'Neutral' },
            { label: 'neutral-outlined', name: 'Neutral outlined' },
            { label: 'ghost', name: 'Ghost' },
            { label: 'filled-on-color', name: 'Filled on color' },
            { label: 'outline-on-color', name: 'Outline on color' },
            { label: 'custom', name: 'Custom' }
          ]
        },
        {
          name: 'iconName',
          type: 'object',
          param: 'iconName',
          objectKey: [
            { key: 'name', type: 'input', value: 'ico_plus_circle' },
            { key: 'isTwoTone', type: 'boolean', value: 'false' },
            { key: 'color', type: 'input', value: '#000' },
            { key: 'color2', type: 'input', value: '#fff' }
          ]
        },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'large',
          option: [
            { label: 'small', name: 'Small' },
            { label: 'medium', name: 'Medium' },
            { label: 'large', name: 'Large' }
          ]
        },
        {
          name: 'shape',
          type: 'select',
          param: 'shape',
          default: 'round',
          option: [
            { label: 'round', name: 'Round' },
            { label: 'square', name: 'Square' }
          ]
        },
        { name: 'backgroundColor', type: 'input', param: 'backgroundColor', default: '' },
        { name: 'disabled', type: 'boolean', param: 'disabled' }
      ],

      form: {
        type: 'filled',
        size: 'medium',
        disabled: false,
        iconName: { name: 'ico_plus_circle', isTwoTone: false },
        backgroundColor: ''
      }
    }
  }
}
</script>
